import { render, staticRenderFns } from "./flight-lookup.vue?vue&type=template&id=327e66a2&scoped=true"
import script from "./flight-lookup.vue?vue&type=script&lang=ts"
export * from "./flight-lookup.vue?vue&type=script&lang=ts"
import style0 from "./flight-lookup.vue?vue&type=style&index=0&id=327e66a2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e66a2",
  null
  
)

export default component.exports